import { closestCorners, DndContext } from '@dnd-kit/core';
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as PlusIcon } from '../../../assets/icons/plus.svg';
import '../scss/qr-configuration.scss';
import MyButton from '../../../shared-components/button/Button';

import DragAndDrop from './DragAndDrop';

interface NewConfigTypes {
  id: number;
  key: string;
  text: string;
  display: boolean;
  fontFamily: string;
  fontSize: string;
  editingText: boolean;
}

/**
 * QR Configuration Component
 * @returns
 */
function QrConfiguration({
  values,
  setValues,
  handleChange,
  deviceSNo,
  serialNumbersToDownload,
}: any) {
  const {t} = useTranslation('qrCode')
  /**
   * Getting Position form State
   * @param id
   * @returns
   */
  const getValuePos = (id: any) => values.findIndex((value: any) => value.id === id);

  /**
   * Updating New Position In State
   * @param event
   * @returns
   */
  const handleDragEnd = (event: any) => {
    const { active, over } = event;

    if (active.id === over.id) return;
    setValues((value: any) => {
      const originalPos = getValuePos(active.id);
      const newPos = getValuePos(over.id);

      return arrayMove(value, originalPos, newPos);
    });
  };

  /**
   * Handling Click Action
   * @returns
   */
  const handleClick = () => {
    const newConfig: NewConfigTypes = {
      id: values.length + 1,
      key: `T${values.length - 1}`,
      text: t('sampleText'),
      display: true,
      fontFamily: 'Inter',
      fontSize: '16',
      editingText: false,
    };

    setValues((previous: any) => [...previous, newConfig]);
  };

  return (
    <div className="qr-config-wrap">
      <div className="qr-config-section">
        <div className="qr-config-creater">
          <div className="qr-config-adder">
            <p>{t('key')}</p>
            <p>{t('value')}</p>
            <MyButton
              label={t('add')}
              buttonType="submit"
              svgIcon={<PlusIcon />}
              onClickFunc={handleClick}
            />
          </div>
          <div className="bottom-line" />
          <div className="qr-config-dnd">
            <DndContext onDragEnd={handleDragEnd} collisionDetection={closestCorners}>
              <SortableContext items={values} strategy={verticalListSortingStrategy}>
                <div>
                  {values?.map((value: any) => (
                    <DragAndDrop
                      handleChange={handleChange}
                      values={value}
                      id={value.id}
                      serialNumbersToDownload={serialNumbersToDownload}
                      deviceSNo={deviceSNo}
                    />
                  ))}
                </div>
              </SortableContext>
            </DndContext>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QrConfiguration;
